export default __webpack_public_path__ + "static/media/visa.4111acd2.svg";